module.exports = __webpack_public_path__ + "static/img/first2.3597012.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/first2.png
// module id = HyRy
// module chunks = 25